import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'
import { AdvisorWithRatingBreakdown, AdvisorUsername, AdvisorUid, RawAdvisorReview } from 'components/features/coaching/advisor/types/advisor'
import { MeetingUid } from 'components/features/coaching/advisorPage/types/interfaces'
import { RawForwardPaginatable } from 'interfaces/table'
import { AdvisorMeetingWizardFields, FlowSpecificFields } from 'components/features/coaching/advisorMeeting/types/requests'
import { AdvisorsRequestResponse } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'

export class GetPublicAdvisorAction extends createRequestAction<'GET_PUBLIC_ADVISOR', { username: string }, AdvisorWithRatingBreakdown>('GET_PUBLIC_ADVISOR') {}

export type GetPublicAdvisorReviewsPayload =
  | { meeting_uid: MeetingUid }
  | { advisor_username: AdvisorUsername }
  | { advisor_uid: AdvisorUid }
export class GetPublicAdvisorReviewsAction extends createRequestAction<'GET_PUBLIC_ADVISOR_REVIEWS', GetPublicAdvisorReviewsPayload, RawForwardPaginatable<RawAdvisorReview>>('GET_PUBLIC_ADVISOR_REVIEWS') {}

type GetPublicAdvisorTimeslotsPayload =
  & Pick<AdvisorMeetingWizardFields, 'advisor_uid' | 'topics' | 'notes'>
  & FlowSpecificFields
export class GetPublicAdvisorTimeslotsAction extends createRequestAction<'GET_PUBLIC_ADVISOR_TIMESLOTS', GetPublicAdvisorTimeslotsPayload, Pick<AdvisorsRequestResponse, 'timeslots' | 'timeslotsPagination'>, void>('GET_PUBLIC_ADVISOR_TIMESLOTS') {}

export type AdvisorPublicActions =
  | typeof GetPublicAdvisorAction.Type
  | typeof GetPublicAdvisorReviewsAction.Type
  | typeof GetPublicAdvisorTimeslotsAction.Type
